import React, { useState } from 'react';
import { getAvatarColor } from '../utils/avatar';
import { useAvatarUrl } from '../utils/avatars';

// 프로필 사진이 있으면 사진, 없으면(또는 불러오기 실패) 이름 첫 글자 + 사용자별 색
export function Avatar({ userId, name = '', className = 'avatar', onClick, title, children }) {
    const url = useAvatarUrl(userId);
    const [brokenUrl, setBrokenUrl] = useState(null);
    const showPhoto = !!url && brokenUrl !== url;
    return (
        <div className={`${className}${showPhoto ? ' has-photo' : ''}`}
            style={showPhoto ? undefined : { backgroundColor: getAvatarColor(userId || name) }}
            onClick={onClick} title={title} role={onClick ? 'button' : undefined}>
            {showPhoto
                ? <img src={url} alt="" loading="lazy" decoding="async" draggable="false" onError={() => setBrokenUrl(url)} />
                : String(name).substring(0, 1).toUpperCase()}
            {children}
        </div>
    );
}
